import { Component, Inject } from '@angular/core';
import { FADE_IN } from '../../../util/animations/animation';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { CommunicationService } from '../../../services/communication/communication.service';
import { PrintCustomDataPopupComponent } from '../print-custom-data-popup/print-custom-data-popup.component';
/**
 * This component is used to display the list of available print templates 
 */
@Component({
  selector: 'app-invoice-templates',
  templateUrl: './invoice-templates-popup.component.html',
  styleUrls: ['./invoice-templates-popup.component.scss'],
  animations: [ FADE_IN ]
})
export class InvoiceTemplatesPopupComponent {
  isSkeleton = false;
  templates = [];
  endpoints = [];
  communicationListeners = [];
  selectedTemplateToPrint;

  constructor( public dialogRef: MatDialogRef<InvoiceTemplatesPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public popupData,
    private dialog: MatDialog,
    private communicationService: CommunicationService) {
      this.communicationService.isLoadMedia(true);
      let sub = this.communicationService.getTemplates.subscribe(templates=>{
        this.templates = templates.filter(x=> x.templateType === 'printTemplate');
      })
      this.communicationListeners.push(sub);

      sub = this.communicationService.getTemplateData.subscribe(templateData=>{
        this.isSkeleton = true;
        if(!templateData.allDocuments)
          this.isSkeleton = false;
        else if(templateData.allDocuments.length)
          this.isSkeleton = false;
      })
      this.communicationListeners.push(sub);
    }

  onClosePopup(): void {
    this.dialogRef.close();
  }

  getPrintTemplateId(index){
    return `printTemplate${index}`;
  }

  ngOnDestroy(): void {
    this.communicationListeners.map(x=>{
      x.unsubscribe();
    })
  }

  onPrintClick(template, index){ 
    this.selectedTemplateToPrint = `printTemplate${index}`
    if(template.questions&&template.questions.length){
      const dialogRef = this.dialog.open(PrintCustomDataPopupComponent, {
        width: '600px',
        minHeight: '50vh',
        maxHeight: '95vh',
        panelClass: 'custom-dialog-container',
        disableClose: true,
        data: template
      });
      dialogRef.afterClosed().subscribe(result => {
        if(result&&result.action){
          template.loadTemplate = true; 
        }       
      })
    }else{
      template.loadTemplate = true;
    }
  }

  onLoad(){
    setTimeout(x=>{
      const el = document.getElementById(this.selectedTemplateToPrint);
      el.click();
      this.templates.map(x=> { x.loadTemplate = false});
      this.selectedTemplateToPrint = null;
    }, 0)
  }

}
